import db from '@/rxdb/database';
import { map } from 'rxjs';
import { getCachedObservable } from '@/rxdb/observablesCache';

export function getWeatherIssuesExport(projectId, weatherIssuesExportId) {
    return db
        .getProjectCollections(projectId)
        .weatherIssuesExports.findOne({ selector: { id: weatherIssuesExportId } })
        .$.pipe(map(mapWeatherIssuesExport));
}

export function getLastWeatherIssuesExport(projectId) {
    return db
        .getProjectCollections(projectId)
        .weatherIssuesExports.findOne({ selector: {}, sort: [{ createdAt: 'desc' }] })
        .$.pipe(map(mapWeatherIssuesExport));
}

export async function removeWeatherIssuesExport(projectId, weatherIssuesExportId) {
    const entity = await db
        .getProjectCollections(projectId)
        .weatherIssuesExports.findOne({ selector: { id: weatherIssuesExportId } })
        .exec();
    return entity.remove();
}

function mapWeatherIssuesExport(weatherIssuesExport) {
    if (weatherIssuesExport) {
        return {
            ...weatherIssuesExport.toMutableJSON(),
            filter: weatherIssuesExport.filter ? JSON.parse(JSON.stringify(weatherIssuesExport.filter)) : [],
        };
    } else {
        return null;
    }
}

export function getWeatherIssuesExports(projectId) {
    return getCachedObservable('getWeatherIssuesExports_' + projectId, () =>
        db
            .getProjectCollections(projectId)
            .weatherIssuesExports.find({ selector: {}, sort: [{ createdAt: 'asc' }] })
            .$.pipe(map((entities) => entities.map(mapWeatherIssuesExport))),
    );
}

export async function createWeatherIssuesExport(projectId, weatherIssuesExport) {
    const result = await db.getProjectCollections(projectId).weatherIssuesExports.insert({
        ...weatherIssuesExport,
        filter: weatherIssuesExport.filter ? JSON.parse(JSON.stringify(weatherIssuesExport.filter)) : [],
    });
    return result.toJSON();
}
